import script from "./person-select.vue?vue&type=script&setup=true&lang=js"
export * from "./person-select.vue?vue&type=script&setup=true&lang=js"

import "./person-select.vue?vue&type=style&index=0&id=e39103fa&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e39103fa"]])

export default __exports__